// extracted by mini-css-extract-plugin
export default {"previewMessage":"IUV7xPB6H4g_Mla_TGCm","title":"wbv_WuTILGdoNciJ8XWA","body":"UbOH0fJcWehyw3kB59OR"};